import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { _list } from './_list'
import { _openOffer } from './_openOffer'
import { useSelector } from 'react-redux';
import { Row, Col, Card, Modal, Spin } from 'antd';
import { MsgBox } from '../../../shared/custom-ant-d'
import { reqGetDPCSText, reqGetRetrieveOffers } from '../../../axios/api';

export const Offers = () => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const history = useHistory();
  const Auth = useSelector(state => state.Auth);
  const [isLoading, setIsLoading] = useState(false);
  const [OfferList, setOfferList] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [termContent, setTermContent] = useState('');
  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);

  useEffect(() => {
    if (OfferList == null && Auth.candidateID != "") {
      setIsLoading(true);
      reqGetRetrieveOffers(Auth.candidateID)
        .then(res => {
          if (res.data.length > 0) {
            setOfferList(res.data);
          }
          setIsLoading(false);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [Auth, OfferList]);

  useEffect(() => {
    if (query.get('offerID') != null && OfferList !== null) {
      var Offer = OfferList.filter(i => i.offerID == query.get('offerID'));
      if (Offer.length > 0) {
        setSelectedOffer(Offer[0]);
      }
      else {
        setSelectedOffer(null);
        MsgBox({
          type: 'error',
          message: 'Error',
          description: 'This offer does not exist.',
        });
      }
    }
    else {
      setSelectedOffer(null);
    }
  }, [query.get('offerID'), OfferList]);

  const onViewOffer = (e, item) => {
    e.preventDefault();
    setSelectedOffer(item);
    return history.push({
      pathname: '/offers',
      search: "?offerID=" + item.offerID,
      state: null,
    });
  }

  const showTermsModal = (e) => {
    e.preventDefault();
    setIsTermsModalVisible(true);

    if (!termContent && Auth.countryID) {
      reqGetDPCSText(Auth.countryID)
        .then(res => {
          setTermContent(res.data);
        })
        .catch(err => {
          console.log(err);
          setTermContent('Unable to load the data privacy statement. Please try again later.');
        });
    }
  }

  const handleCloseTermsModal = (e) => {
    if (e) {
      e.preventDefault();
    }

    setIsTermsModalVisible(false);
  }

  return (
    <>
      {
        (selectedOffer == null) ?
          (
            <_list
              {...{
                OfferList,
                onViewOffer,
                isLoading
              }}
            />
          ) :
          (
            <_openOffer
              {...{ selectedOffer, setSelectedOffer, setOfferList }}
            />
          )
      }
      <Row justify="left">
        <Col md={24} xs={24}>
          <Card bordered={false}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <span>Terms of Use: <a href="/" onClick={showTermsModal}>Data Privacy</a></span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        title="Data Privacy Consent Statement"
        visible={isTermsModalVisible}
        onCancel={handleCloseTermsModal}
        className="terms-modal"
        destroyOnClose
        width={850}
        footer={null}
      >
        <div id="terms-content">
          {termContent ? <div dangerouslySetInnerHTML={{ __html: termContent }}></div> : <Spin />}
        </div>
      </Modal>
    </>
  )
}
